import React from 'react';
import {Typography} from "@mui/material";
import LoggedLayout from "../../component/LoggedLayout";

 const ArenaView = () => {
    return (
        <LoggedLayout>
            <Typography>Arena view</Typography>
        </LoggedLayout>
    )
}

export default ArenaView